var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnlock = function SvgUnlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 9.33398H9.33329C6.75596 9.33398 4.66663 11.4233 4.66663 14.0007V21.0007C4.66663 23.578 6.75596 25.6673 9.33329 25.6673H18.6666C21.244 25.6673 23.3333 23.578 23.3333 21.0007V14.0007C23.3333 11.4233 21.244 9.33398 18.6666 9.33398ZM18.6666 9.33398L18.6667 7.00065C18.6667 4.42332 16.5773 2.33398 14 2.33398C12.2727 2.33398 10.7645 3.27245 9.95764 4.66732M16.3333 17.5007C16.3333 18.7893 15.2886 19.834 14 19.834C12.7113 19.834 11.6666 18.7893 11.6666 17.5007C11.6666 16.212 12.7113 15.1673 14 15.1673C15.2886 15.1673 16.3333 16.212 16.3333 17.5007Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unlock.1ee5e74b.svg";
export { ForwardRef as ReactComponent };